<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useMapGetter } from 'dashboard/composables/store';

import ContactInfo from 'dashboard/routes/dashboard/conversation/contact/ContactInfo.vue';
import CustomAttributes from 'dashboard/routes/dashboard/conversation/customAttributes/CustomAttributes.vue';
import AccordionItem from 'dashboard/components/Accordion/AccordionItem.vue';

const props = defineProps({
  contactId: { type: Number, required: true },
});

const store = useStore();
const contactGetter = useMapGetter('contacts/getContact');

// The requester as the conversation sidebar shows them: the same contact card (edit, merge,
// new conversation) and the same contact attributes, read from and saved to the contacts
// store. The card JSON only carries a summary of the contact, so the full record is fetched.
const contact = computed(() => contactGetter.value(props.contactId));

const isAttributesOpen = ref(true);

onMounted(() => store.dispatch('contacts/show', { id: props.contactId }));
</script>

<template>
  <section class="flex flex-col">
    <h2 class="px-5 mb-0 text-xs font-medium uppercase text-n-slate-10">
      {{ $t('CARDS.SHOW.CONTACT') }}
    </h2>
    <ContactInfo :contact="contact" :show-actions="false" />
    <!-- The same spacing the conversation sidebar gives its sections (ContactPanel). -->
    <div class="px-2">
      <AccordionItem
      :title="$t('CONVERSATION_SIDEBAR.ACCORDION.CONTACT_ATTRIBUTES')"
      compact
      :draggable="false"
      :is-open="isAttributesOpen"
      @toggle="isAttributesOpen = !isAttributesOpen"
    >
      <CustomAttributes
        attribute-type="contact_attribute"
        attribute-from="card_contact_panel"
        :contact-id="contactId"
        :empty-state-message="
          $t('CONVERSATION_CUSTOM_ATTRIBUTES.NO_RECORDS_FOUND')
        "
        />
      </AccordionItem>
    </div>
  </section>
</template>
